module.exports = __webpack_public_path__ + "img/preview-1.48d84ae8.png";